<div class="details-container">
  <div
    class="details-header"
    style="background: url(assets/images/readingboys1.jpg)"
  >
    <div class="details-banner">
      <h1>Reading School for Boys 11 Plus</h1>
      <h2>11 Plus (11+) Exam Information</h2>
    </div>
  </div>

  <div class="details-publisher">
    <span><strong>Published by - SEHYOG Academy</strong></span>
  </div>

  <div class="details-content">
    <div class="details-section">
      <h3>Introduction</h3>

      <div class="spacer"></div>

      <p>
        Reading School, situated in Berkshire, is a distinguished boys’ grammar
        school with academy status. Established as a part of Reading Abbey in
        1125, it ranks among England’s oldest schools. Throughout its history,
        it has continued to uphold its dedication to educational excellence.
        Currently, Reading School occupies a scenic campus featuring
        cutting-edge facilities that inspire an atmosphere conducive to
        learning. <br />
        <br />

        The school delivers a wide-ranging and all-encompassing curriculum to
        address students’ intellectual, creative, and physical growth. It
        provides an array of subjects, such as English, mathematics, sciences
        (biology, chemistry, and physics), humanities (history, geography, and
        religious studies), modern foreign languages (French, German, and
        Spanish) and the arts (painting, music, and drama). <br />
        <br />

        Apart from its robust academic offerings, Reading School emphasises the
        value of extracurricular pursuits to foster personal development and a
        well-balanced lifestyle. Students can choose from a wide selection of
        clubs, spanning interests like chess, robotics, debate, and photography.
        It also boasts a varied sports program offering participation in
        athletics, cricket, rugby, and football, among other activities. <br />
        <br />

        The central ethos of Reading School is its dedication to academic and
        individual growth and the development of a caring and supportive
        community. It nurtures intellectual curiosity, perseverance, and
        independent thinking, empowering students to reach their utmost
        potential. <br />
        <br />

        Reading School has a long history of outstanding academic achievements,
        regularly ranking among the top schools in the United Kingdom. Students
        at Reading School score high in GCSEs and A-levels, achieving top marks.
        A substantial number of students from the school have secured admission
        to esteemed universities.
      </p>

      <div class="spacer"></div>

      <div class="spacer"></div>

      <h2>Reading School for Boys 11 Plus (11+) Exam Information 2025</h2>

      <p><strong>Address: </strong> Erleigh Road, Reading RG1 5LW</p>
      <p><strong>County: </strong>Berkshire</p>
      <p>
        <strong>Admissions info:</strong> Secretary&#64;reading-school.co.uk, 0118
        9015600
      </p>
      <p><strong>School type: </strong> Boys’ Grammar</p>
      <p><strong>Number of pupils: </strong> 890</p>
      <p>
        <strong>Number of places in Year 7:</strong> 150: 12 boarders (maximum)
        and 138 day pupils (minimum)
      </p>
      <p><strong>Open Day date: </strong> April and May</p>
      <p><strong>Exam date:</strong> September 2025</p>
      <p><strong>Pass mark: </strong> Aim for 80%+ in our practice tests.</p>
      <p>
        <strong>Exam type / Board: </strong> FSCE (Future Stories Community
        Enterprise)
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Reading School for Boys 11 Plus (11+) Admissions</h2>

      <div class="spacer"></div>

      <p>
        Year 7 admission to Reading School for Boys is determined by pupil
        performance in the 11 Plus exam. If you are considering Reading School
        as an option for your son, you are advised to attend one of the school’s
        open days. At the event, you will be able to take a tour of the school,
        talk to staff and get a better understanding of the overall admissions
        process. <br />
        <br />

        Unfortunately, the school cannot guarantee a place for every pupil that
        meets the required standard. The school is heavily oversubscribed and
        uses the following criteria to determine place allocation, giving
        priority to:
      </p>

      <p>
        1. Looked after children or previously looked after children <br />
        2. Students who live within the designated area of the school and is
        eligible for the pupil premium or service premium <br />
        3. Pupils whose home address is within the designated area of the school
        <br />
        4. Students whose home address is not within the designated area of the
        school
      </p>

      <div class="spacer"></div>

      <h2>How to Apply for 11 Plus (11+) Entry to Reading School for Boys</h2>

      <div class="spacer"></div>

      <p>
        To register interest for a Year 7 place at Reading School for Boys,
        parents must complete their Local Authority’s (LA) Common Application
        Form (CAF). To register for the 11+ admissions test itself, parents need
        to complete a separate application directly with the school. This
        registration can be done online when the application window is open.
        Applications received after the school’s deadline will not be accepted.
        <br />
        <br />

        Parents will receive the results of their child’s 11+ exam in October,
        before the deadline for the submission of the CAF.
      </p>

      <h2>Reading School for Boys 11 Plus (11+) Exam Format</h2>

      <p>
        The Reading School for Boys 11+ entrance examination is created by an
        exam board called FSCE. The test consists of the following assessments:
      </p>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>
          <strong>Paper 1:</strong> mathematics and English skills
          (multiple-choice format; 45 minutes in length)
        </p>
      </div>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>
          <strong>Paper 2:</strong> mathematics and English (constrained/free
          response format; 35 minutes in length)
        </p>
      </div>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>Creative Writing (20 minutes in length)</p>
      </div>

      <p>
        The FSCE test will also evaluate imaginative flair by focusing on
        creativity—defined as the skill to develop new ideas or approach
        problems in original and inventive ways. <br />
        <br />
      </p>

      <h2>
        How to Prepare for the Reading School for Boys 11 Plus (11+) Exam?
      </h2>

      <p>
        Reading School for Boys regularly appears towards the top of UK school
        league tables and receives an average of five applications for every
        Year 7 place. In short, your son will have to be thoroughly prepared
        ahead of the exam and have the confidence to believe that he can secure
        his place at the school. <br />
        <br />

        Begin by setting your son a detailed study timetable, split into
        realistic revision sessions, each lasting 30 minutes. These manageable
        blocks of revision will go some way to ensuring that your son doesn’t
        become overworked or distracted. <br />
        <br />

        Introducing our practice exam papers into your son’s routine can help
        give him a better idea of roughly how much time he has to answer each
        question. They can also help monitor his progress and identify weak
        spots.
      </p>

      <h2>
        Reading School for Boys 11 Plus (11+) Exam Pass Marks and Target Scores
      </h2>

      <p>
        The recent standardised pass mark for entry into Reading School was 95
        for Maths and 95 for English (without the creative writing paper).
        Pupils who are able to score 80%+ consistently in our 11+ practice tests
        for Reading School should be on track to pass the 11+ assessment. <br />

        Whilst there are no guarantees, this has historically been a fairly
        strong indicator that your child should do well in the Reading School
        for Boys 11+ exam. Please click here to learn more.
      </p>
    </div>
  </div>
</div>
